import * as React from "react";
import { StickyCallToAction } from "@grandvisionhq/common";
import { StickyPriceView } from "../../components/modules/StickyCta/components/StickyPriceView.js";
import { useProductData } from "../../../../context/context/product-context-hooks.js";
const StickyMobileCtaAndPrice = ({ cta, className, priceSubtitle }) => {
  const { displayPrice } = useProductData();
  return /* @__PURE__ */ React.createElement(
    StickyCallToAction,
    {
      className,
      button: cta,
      price: /* @__PURE__ */ React.createElement(StickyPriceView, { displayPrice }),
      priceSubtitle
    }
  );
};
export {
  StickyMobileCtaAndPrice
};
//# sourceMappingURL=StickyMobileCtaAndPrice.js.map
